import React, { Fragment } from 'react';
import YoastMeta from '@components/YoastMeta';
import '@theme/style.css';
import '@theme/leap/dist/assets/css/theme.min.css';

export default function Layout ({ children, pageContext: { meta }}) {
  return (
    <Fragment>
      {meta &&
        <YoastMeta meta={meta} />
      }
      {children}
    </Fragment>
  );
}